export default "__VITE_ASSET__DHWZz_Cr__"